// Start Copilot generated
// Runtime type checking utilities to safely validate data types at runtime
// These protect against malformed GraphQL responses that could cause page crashes
var isString = function (value) { return typeof value === 'string'; };
var isArray = function (value) { return Array.isArray(value); };
var isObject = function (value) {
    return value !== null && typeof value === 'object';
};
// Safe property access utility that prevents errors when traversing potentially malformed objects
// Returns defaultValue if any part of the path is null/undefined or doesn't exist
var safeGet = function (obj, path, defaultValue) {
    try {
        var result = path.reduce(function (current, key) {
            if (!isObject(current) || !(key in current)) {
                throw new Error('Path not found');
            }
            return current[key];
        }, obj);
        return result;
    }
    catch (_a) {
        return defaultValue;
    }
};
// Safe function execution utility that catches any runtime errors and returns fallback value
// Prevents uncaught exceptions from crashing the application
var safeTry = function (fn, fallback) {
    try {
        return fn();
    }
    catch (_a) {
        return fallback;
    }
};
// End Copilot generated
var getIsAuthError = function (error) {
    var graphQLErrors = safeGet(error, ['graphQLErrors'], []);
    if (!isArray(graphQLErrors))
        return false;
    return graphQLErrors.some(function (graphQLError) {
        var message = safeGet(graphQLError, ['message'], '');
        return isString(message) && message.includes('AUTH_ERR_105');
    });
};
var hasErrorCode = function (errorCode, error) {
    var graphQLErrors = safeGet(error, ['graphQLErrors'], []);
    if (!isArray(graphQLErrors))
        return false;
    return graphQLErrors.some(function (graphQLError) {
        var errors = safeGet(graphQLError, ['extensions', 'errors'], []);
        if (isArray(errors)) {
            var hasInExtensions = errors.some(function (err) { return isObject(err) && safeGet(err, ['errorCode'], '') === errorCode; });
            if (hasInExtensions)
                return true;
        }
        var message = safeGet(graphQLError, ['message'], '');
        return isString(message) && message.includes(errorCode);
    });
};
var extractErrorCode = function (errorMessage) {
    if (!isString(errorMessage))
        return undefined;
    return safeTry(function () {
        var errorPattern = /[A-Z]+_[A-Z]+_\d+/;
        var match = errorMessage.match(errorPattern);
        return match === null || match === void 0 ? void 0 : match[0];
    }, undefined);
};
/**
 * Main function used by newrelic.ts for GraphQL error tracking
 * Safely extracts error information from potentially malformed GraphQL responses
 */
// Helper function to collect all error codes from GraphQL response
var collectAllErrorCodes = function (response) {
    var allErrorCodes = [];
    var graphQLErrors = safeGet(response, ['graphQLErrors'], []);
    if (!isArray(graphQLErrors))
        return allErrorCodes;
    graphQLErrors.forEach(function (graphQLError) {
        // Collect error codes from extensions
        var errors = safeGet(graphQLError, ['extensions', 'errors'], []);
        if (isArray(errors)) {
            errors.forEach(function (err) {
                var errorCode = safeGet(err, ['errorCode'], '');
                if (isString(errorCode) &&
                    errorCode &&
                    !allErrorCodes.includes(errorCode)) {
                    allErrorCodes.push(errorCode);
                }
            });
        }
        // Collect error codes from direct messages
        var message = safeGet(graphQLError, ['message'], '');
        if (isString(message)) {
            var extractedCode = extractErrorCode(message);
            if (extractedCode && !allErrorCodes.includes(extractedCode)) {
                allErrorCodes.push(extractedCode);
            }
        }
    });
    return allErrorCodes;
};
export var trackGraphQlError = function (response) {
    // Start Copilot generated
    // Wraps the entire error processing logic in a safe try-catch to prevent page crashes
    // from malformed GraphQL error responses - returns fallback error message if anything fails
    return safeTry(function () {
        // End Copilot generated
        // Collect all error codes first
        var allErrorCodes = collectAllErrorCodes(response);
        if (getIsAuthError(response)) {
            return {
                errorCode: 'AUTH_ERR_105',
                allErrorCodes: allErrorCodes.length > 0 ? allErrorCodes : undefined,
            };
        }
        if (hasErrorCode('PB_ERR_004', response)) {
            return {
                errorCode: 'PB_ERR_004',
                allErrorCodes: allErrorCodes.length > 0 ? allErrorCodes : undefined,
            };
        }
        if (allErrorCodes.length === 0) {
            var message = safeGet(response, ['message'], '');
            return { errorMessage: message || 'No errorCode provided' };
        }
        var firstErrorCode = allErrorCodes[0];
        return {
            errorCode: firstErrorCode,
            allErrorCodes: allErrorCodes,
        };
    }, {
        errorMessage: 'An error occurred while processing the error response',
        allErrorCodes: undefined,
    });
};
